import { render, staticRenderFns } from "./InternalServerError.vue?vue&type=template&id=3b97dfde&scoped=true&"
import script from "./InternalServerError.vue?vue&type=script&lang=js&"
export * from "./InternalServerError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97dfde",
  null
  
)

export default component.exports